export function isSupportedBrowser() {
    if (!window.PointerEvent)
        return false;
    if (!window.ResizeObserver)
        return false;
    return true;
}
